import React, { useState ,useEffect} from 'react'
import styles from './SideTable.module.scss'
import { useGeoState,useGeoFetch } from '../../components/GeoProvider'
import HorizontalColumnBarChart from '../../components/HorizontalColumnBarChart'
import ErrorLogs from '../../components/ErrorBoundary/errorlogs'
import { useAuthState } from '../../components/AuthProvider'
import Spinner from '../../components/Loader/Spinner'
import ErrorMessage from '../../components/Layout/ErrorMessage'
import getAllergyDiseaseNameById from '../../utils/getAllergyDiseaseNameById'
const AllergyCondition=({geo_id,geo_type,disease_id})=>{
  const { user } = useAuthState()
  const [errorCode, setErrorCode] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [getAllergyData, setAllergyData] = useState()
  const [isLoading,setIsLoading] =useState(false)
  const {
    locationName,
    displayDate
  } = useGeoState()
  const { data: statesData, error: MapError } = useGeoFetch(
    displayDate,
    displayDate,
    'allergiesconditions',
    `${geo_type}/${disease_id}/?geo_id=${geo_id}`
  )

  useEffect(() => {
    setIsLoading(true)
    if (statesData !== null && statesData !== undefined) {
      if (statesData.response_code === 200) {
        ErrorLogs({
          message_type: 'Activity',
          error_details: 'Dashboard access success',
          user: user,
        })
        setAllergyData(statesData.response_data)
        seterrorOccured(false)
      } else {
        setErrorCode(statesData.response_code)
        setErrorMessage(statesData.response_message)
        setErrorSubject(statesData.response_subject)
        seterrorOccured(true)
      }
      setIsLoading(false)
    }
  }, [statesData])

  if ( MapError || errorOccured ) {
    return (
      <ErrorMessage
        errorCode={errorCode}
        errorMessage={errorMessage}
        errorSubject={errorSubject}
        errorDetails={errorMessage}
      />
    )
  }
  return (
    getAllergyData!==undefined&&!isLoading?
    <HorizontalColumnBarChart data={getAllergyData} chartName="columnBarChartAllergies" 
    locationName={locationName} 
    chart_data_type='allergy'
    height={180}
    />  :<Spinner/>
  )
  
}

const PlaceOfService=({geo_id,geo_type,disease_id})=>{
  const { user } = useAuthState()
  const [errorCode, setErrorCode] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [getPosData, setPosData] = useState()
  const [isLoading,setIsLoading] =useState(false)
  const {
    locationName,
    displayDate
  } = useGeoState()
  const { data: statesData, error: MapError } = useGeoFetch(
    displayDate,
    displayDate,
    'allergiespos',
    `${geo_type}/${disease_id}/?geo_id=${geo_id}`
  )

  useEffect(() => {
    setIsLoading(true)
    if (statesData !== null && statesData !== undefined) {
      if (statesData.response_code === 200) {
        ErrorLogs({
          message_type: 'Activity',
          error_details: 'Dashboard access success',
          user: user,
        })
        seterrorOccured(false)
        setPosData(statesData.response_data)
      } else {
        setErrorCode(statesData.response_code)
        setErrorMessage(statesData.response_message)
        setErrorSubject(statesData.response_subject)
        seterrorOccured(true)
      }
      setIsLoading(false)
    }
  }, [statesData])
  if ( MapError || errorOccured ) {
    return (
      <ErrorMessage
        errorCode={errorCode}
        errorMessage={errorMessage}
        errorSubject={errorSubject}
        errorDetails={errorMessage}
      />
    )
  }
  return (
    getPosData!==undefined&&!isLoading?
    <HorizontalColumnBarChart data={getPosData} chartName="columnBarChartAllergies" 
    locationName={locationName} 
    chart_data_type='pos'
    height={180}
    />  :<Spinner/>
  )
}


const SideTable = ({ geo_id,geo_type,disease_id}) => {
  return (
    <div className={styles.base}>
      <div className={styles.allergic} >
      <div className={styles.header}>
      <div>
          <span className={styles.captionFormat}>
             {getAllergyDiseaseNameById(disease_id)} Conditions
            {/* <p className={styles.subCaptionFormat}>
            Interact with chart to view more details.
            </p> */}
          </span>
        </div>
      </div>
      <div className={styles.componentDiv}>
        <AllergyCondition geo_id={geo_id}
        geo_type={geo_type}
        disease_id={disease_id}/>
      </div>
      </div>
      <div className={styles.pos} >
      <div className={styles.header}>
      <div>
          <span className={styles.captionFormat}>
            Place of Service
          </span>
        </div>
      </div>
      <div className={styles.componentDiv}>
        <PlaceOfService geo_id={geo_id}
        geo_type={geo_type}
        disease_id={disease_id}/>
      </div>
      </div>
    </div>
  )
}

export default SideTable
